import { FC } from 'react'

import { ButtonProps } from './types'
import DefaultButton from './DefaultButton'
import CancelButton from './CancelButton'

export * from './BaseButton'
export * from './CommonButton'
export * from './Button'
export * from './TextButton'

interface ButtonSubComponents {
  Cancel: typeof CancelButton
}

/**
 * @deprecated Please use Button instead
 */
const LegacyButton: FC<ButtonProps> & ButtonSubComponents = (
  props: ButtonProps,
) => <DefaultButton {...props} />

LegacyButton.Cancel = CancelButton

export default LegacyButton
